<div>
    @for (item of sortedList(); track $index) {
    <div (click)="onSelect.emit(item)" class="cursor-pointer mb-2 flex justify-between items-center">
        <div>{{item.priceDate}}</div>
        <div>{{ item.priceValue | currency:'EUR':'symbol':'1.3-3' }}</div>
    </div>
    }
    
</div>